import React from 'react';
import {
  ColumnInformation,
  joinClassNames,
  TableSorterField,
  TableSorterInformation,
} from '@utahdts/dts-react-common';
import TableSorterSortType from '@utahdts/dts-react-common/components/table-sorter/TableSorterSortType';
import TableSorterDirection from '@utahdts/dts-react-common/components/table-sorter/TableSorterDirection';
import { dateTd, textTd } from '../../misc/Shared';
import Icon from '../../misc/Icon';
import RowActionsPopover from '../../misc/RowActionsPopover';

const customTd = (columnInfo, data, editPatent, deletePatent) => {
  return (
    <td key={joinClassNames(columnInfo.field, data.name)}>
      <RowActionsPopover>
        <ul className="actions">
          <li
            className="actions-item"
            onClick={() => editPatent(true, data, true)}
          >
            {Icon.iconPencil()} Edit Patent
          </li>
          <li className="actions-item" onClick={() => deletePatent(data)}>
            {Icon.iconTrash()} Delete Patent
          </li>
        </ul>
      </RowActionsPopover>
    </td>
  );
};

const sorters = {
  companyName: new TableSorterField(
    'companyName',
    TableSorterSortType.TEXT,
    TableSorterDirection.ASCENDING,
  ),
  patentLostDate: new TableSorterField(
    'patentLostDate',
    TableSorterSortType.DATE,
    TableSorterDirection.ASCENDING,
  ),
  drugDescription: new TableSorterField(
    'drugDescription',
    TableSorterSortType.TEXT,
    TableSorterDirection.ASCENDING,
  ),
  createdDate: new TableSorterField(
    'createdDate',
    TableSorterSortType.DATE,
    TableSorterDirection.DESCENDING,
  ),
};

const defaultSorters = (firstSorter) =>
  new TableSorterInformation([
    firstSorter,
    ...Object.values(sorters).filter((sorter) => sorter !== firstSorter),
  ]);

export default (editPatent, deletePatent) => [
  new ColumnInformation({
    title: 'Company Name',
    field: 'companyName',
    tableSorterInformation: defaultSorters(sorters.companyName),
    tdCallback: textTd,
  }),
  new ColumnInformation({
    title: 'Drug Name',
    field: 'drugDescription',
    tableSorterInformation: defaultSorters(sorters.drugDescription),
    tdCallback: textTd,
  }),
  new ColumnInformation({
    title: 'Patent Expiration Date',
    field: 'patentLostDate',
    tableSorterInformation: defaultSorters(sorters.patentLostDate),
    tdCallback: (columnInfo, data) => dateTd(columnInfo, data, false),
  }),

  new ColumnInformation({
    title: 'Date Submitted',
    field: 'createdDate',
    tableSorterInformation: defaultSorters(sorters.createdDate),
    tdCallback: (columnInfo, data) => dateTd(columnInfo, data, true),
  }),
  new ColumnInformation({
    title: 'Actions',
    field: 'actions',
    tdCallback: (columnInfo, data) =>
      customTd(columnInfo, data, editPatent, deletePatent),
    filter: false,
  }),
];
